let lenis;
let hideScrollbarTimeout;

document.addEventListener('DOMContentLoaded', function () {
  initLenis();
  if (lenis) {
    Scrollbar();
  }
});


function initLenis() {
  const isScrubsLP =
    document.body.classList.contains('template-page-lp-conjunto-scrubs');

  const isMobile = window.matchMedia('(max-width: 768px)').matches;

  if (isScrubsLP && isMobile) {
    return;
  }

  // código atual da função continua aqui...
  lenis = new Lenis({
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
    direction: 'vertical',
  });

  // Solução para o problema do modal: quando o modal é aberto, paramos a Lenis, e quando é fechado, reiniciamos.
  //window.lenis = lenis;

  const modal = document.querySelector('[id^="SizeChart"]');

  if (modal) {
    const observer = new MutationObserver(() => {
      const isVisible = modal.offsetParent !== null;

      if (isVisible) {
        lenis.stop();
      } else {
        lenis.start();
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class', 'style', 'open', 'aria-hidden'],
    });
  }

  modal?.addEventListener('wheel', (e) => {
    e.stopPropagation();
  }, { passive: false });
  // Onde se encerra a solução do modal

  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }

  requestAnimationFrame(raf);

  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      if (typeof lenis.update === 'function') {
        lenis.update();
      }
    }, 150);
  });

  lenis.on('scroll', () => {
    showScrollbarTemporarily();
  });
}

function showScrollbarTemporarily() {
  document.documentElement.classList.add('show-scrollbar');

  clearTimeout(hideScrollbarTimeout);

  hideScrollbarTimeout = setTimeout(() => {
    document.documentElement.classList.remove('show-scrollbar');
  }, 100);
}

function Scrollbar() {
  let start = null;

  const scrollbar = document.getElementById('scrollbar');
  const inner = scrollbar.querySelector('.inner');
  const thumb = scrollbar.querySelector('.thumb');

  let innerHeight = inner.offsetHeight;
  let thumbHeight = thumb.offsetHeight;

  function mapRange(value, inMin, inMax, outMin, outMax) {
    return ((value - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin;
  }

  function updateThumbPosition(scroll, limit) {
    const progress = scroll / limit;
    const maxThumbMove = innerHeight - thumbHeight;
    thumb.style.transform = `translate3d(0, ${progress * maxThumbMove
      }px, 0)`;
  }

  function updateDimensions() {
    innerHeight = inner.offsetHeight;
    thumbHeight = thumb.offsetHeight;
  }

  window.addEventListener('resize', updateDimensions);

  function onPointerMove(e) {
    if (!start) return;
    e.preventDefault();

    const thumbY = e.clientY - start;
    const maxThumbMove = innerHeight - thumbHeight;

    const clampedThumbY = Math.max(0, Math.min(thumbY, maxThumbMove));

    const scroll = mapRange(clampedThumbY, 0, maxThumbMove, 0, lenis.limit);

    lenis.scrollTo(scroll, { immediate: true });
  }

  function onPointerDown(e) {
    start = e.clientY - thumb.getBoundingClientRect().top;
    thumb.classList.add('grabbing');
  }

  function onPointerUp() {
    start = null;
    thumb.classList.remove('grabbing');
  }

  thumb.addEventListener('pointerdown', onPointerDown);
  window.addEventListener('pointermove', onPointerMove);
  window.addEventListener('pointerup', onPointerUp);

  lenis.on('scroll', ({ scroll, limit }) => {
    updateThumbPosition(scroll, limit);
  });
}

const anchorLinks = document.querySelectorAll('a[href^="#"]');

anchorLinks.forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();

    const targetId = link.getAttribute('href').substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      lenis.scrollTo(targetElement);
    }
  });
});